module.exports = __webpack_public_path__ + "img/ps.9e5d947f.svg";